import { GetterTree } from "vuex";
import { SiteMonitorCamerasState } from "./types";
import { RootState } from "../types";
import Vue from "vue";

export const getters: GetterTree<SiteMonitorCamerasState, RootState> = {
	getMediaMatrixCameras: state => state.mediaMatrixCameras,
	getMediaMatrixLayers: state => state.mediaMatrixLayers,
	getMediaMatrixClips: state => state.mediaMatrixClips,
	getAreaCameras: state => state.areaCameras,
	getDeviceControllerCameras: state => state.deviceControllerCameras,
	getDeviceControllerOutputs: state => state.deviceControllerOutputs,
	getDeviceControllerAudioDevices: state => state.deviceControllerAudioDevices,
	getDeviceControllerClips: state => state.deviceControllerClips,
	getLayoutIndex: state => state.layoutIndex,
	getLayouts: state => state.layouts,
	getFilter: state => state.mediaMatrixFilter,
	getMediaMatrixEventId: state => state.mediaMatrixEventId,
	getAwaitingCamera: state => state.awaitingCamera,
	getAwaitingClip: state => state.awaitingClip,
	getAllMatrixContents: state => state.matrixContents,
	getMediaMatrixLastChanged: state => state.mediaMatrixLastChanged,
	getMatrixContents: state => {
		return (index: number) => {
			return state.matrixContents[index.toString()];
		};
	},
	getMatrixAssignedCameras: state => {
		if(!state.matrixContents){
			return [];
		}

		var assignedCameras = [];
		const matrixContentsItems = Object.entries(state.matrixContents) // Filter out duplicate cameras
			.filter(([_, content], idx, arr) => arr.findIndex(([_, c]) => c.camera && content.camera && getCameraId(c) == getCameraId(content)) === idx
							&& !assignedCameras.includes(getCameraId(content)));

		for (const [_, content] of matrixContentsItems) {
			let objectId: number | null = getCameraId(content);
			if (objectId) {
				assignedCameras.push(objectId)
			}
		}

		return assignedCameras;
	},
	getMatrixPushContents: state => {
		return (index: number) => {
			if (state.matrixPushContents === undefined) {
				Vue.set(state.matrixPushContents, index.toString(), null);
			}

			return state.matrixPushContents[index.toString()];
		};
	},
	getRequiresEventDetails: state => state.requiresEventDetails,
	getMediaMatrixIsNew: state => state.mediaMatrixIsNew,
	getFetchingMatrix: state => state.fetchingMatrix,
	getHighlightCellIndex: state => state.highlightCellIndex,
	getLinkRecord: state => state.linkRecord,
	getWaitingForEvents: state => state.waitingForEvent,
	areaCameras: state => state.areaCameras,
	searchedCameras: state => state.searchedCameras,
	searchedOutputs: state => state.searchedOutputs,
	getShownAuditClips: state => state.shownAuditClips,
	getAreaAudioDevices: state => state.areaAudioDevices,
	getNearbyAudioDevices: state => state.nearbyAudioDevices,
	getUserLastLayoutIndex: state => state.userLastLayoutIndex,
};

function getCameraId(content: any): number | null {
	if (!content || !content.camera) {
        return null;
    }
		return content.camera.objectID ?? content.camera.objectId ?? null;
}